import React from "react";
import { observer, inject } from "mobx-react";
import { ReviewsLayout } from "ComponentsUI/Reviews";
import { withRouter, Link } from "react-router-dom";
import { orderBy } from "lodash";
import Block from "ComponentsUI/Block";
import Button from "ComponentsUI/Button";
import { graphql } from "@apollo/client/react/hoc";
import { REVIEWS_MAIN_PAGE_V3 } from "Services/queries";
import { generateUrl } from "Services/withDefaultParams";
import withDefaultParams from "Services/withDefaultParams";
var Routes = require("Configs/routes");

@inject("ApplicationModel")
@observer
class Reviews extends React.Component {
	onClickHandler() {}

	render() {
		let applicationModel = this.props.ApplicationModel;
		let windowSizeModel = this.props.ApplicationModel.windowSizeModel;
		let textConfig = applicationModel.text;
		if (!this.props.data.reviewsMainPage) {
			return null;
		}

		let reviewsUrl = generateUrl(Routes.Reviews.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		let feedbackUrl = generateUrl(Routes.AddReview.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		let reviews = this.props.data.reviewsMainPage.data;
		if (windowSizeModel.windowSizes.md) {
			reviews = reviews.slice(0, 3);
		}

		let windowSizesModel = this.props.ApplicationModel.windowSizeModel;

		reviews = reviews.slice(0, windowSizesModel.windowSizes.md ? 3 : 4);

		if (windowSizesModel.windowSizes.xs || windowSizesModel.windowSizes.sm) {
			reviews = orderBy(reviews, ["date"], ["desc"]);

			if (reviews[0]?.rating_type !== "positive") {
				const idx = reviews.findIndex((x) => x?.rating_type === "positive");

				if (idx !== -1) {
					reviews = [].concat(reviews.splice(idx, 1), reviews);
				}
			}
		}

		return (
			<Block
				header={textConfig.prvidersReviewsTitle}
				datatest="main_review"
				btn={
					<Button
						typeText="big"
						component={<Link to={!!reviewsUrl ? reviewsUrl : "/"} />}
						size={"middle"}
						status={"tertiaryAccent"}
						transparent={true}
						onClick={() => this.onClickHandler()}
						datatest="main_allreviews_button"
						fullWidth={true}
					>
						{textConfig.reviewsAll}
					</Button>
				}
				secondButton={
					<Button
						typeText="big"
						component={<Link to={!!feedbackUrl ? feedbackUrl : "/"} />}
						size={"middle"}
						status={"purple"}
						fullWidth={true}
						onClick={() => this.onClickHandler()}
						datatest="main_allreviews_button"
					>
						{textConfig.ratingLeaveReview}
					</Button>
				}
			>
				<ReviewsLayout useCarusel={true} items={reviews} />
			</Block>
		);
	}
}

export default withRouter(
	withDefaultParams(
		graphql(REVIEWS_MAIN_PAGE_V3, {
			options: (props) => {
				let variables = {};
				if (props.match.params.regionUrl) {
					variables.filter = `region.url=${props.match.params.regionUrl}`;
				}
				return {
					variables: {
						...variables,
						providerJoin: true,
					},
				};
			},
		})(Reviews)
	)
);
